import EducationMasterForm from "./EducationMasterForm";

const AddEducationCategory = () => (
  <EducationMasterForm
    title="Education Category"
    backPath="/all-education-category"
    submitLabel="Add Education Category"
    addEndpoint="/admin/add-education-category"
    getEndpoint="/admin/get-education-category"
    updateEndpoint="/admin/update-education-category"
    responseKey="EducationCategory"
  />
);

export default AddEducationCategory;
